import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  OnDestroy,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'be-swipeable',
  imports: [CommonModule],
  templateUrl: './swipeable.component.html',
  styleUrls: ['./swipeable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--scrollable-action-width]': `actionWidth() + 'px'`,
  },
})
export class SwipeableComponent implements OnDestroy {
  readonly enabled = input(true);
  readonly actionWidth = input(64);
  readonly actionsTpl = input<TemplateRef<any>>();
  readonly actionsContext = input<Record<string, unknown> | null>(null);

  readonly opened = output<boolean>();

  readonly trackRef = viewChild<ElementRef | undefined>('track');

  private timeoutId: any;

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }

  onScroll(event: Event): void {
    if (!this.enabled()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.onScrollEnd(), 120);
  }

  open(): void {
    this.trackRef?.()?.nativeElement.scrollTo({ left: this.actionWidth(), behavior: 'smooth' });
    this.opened.emit(true);
  }

  close(): void {
    this.trackRef?.()?.nativeElement.scrollTo({ left: 0, behavior: 'smooth' });
    this.opened.emit(false);
  }

  private onScrollEnd(): void {
    const el = this.trackRef?.()?.nativeElement;
    if (!el) {
      return;
    }
    const open = el.scrollLeft > this.actionWidth() / 2;
    el.scrollTo({ left: open ? this.actionWidth() : 0, behavior: 'smooth' });
    this.opened.emit(open);
  }
}
